import { createAction, props } from "@ngrx/store";
import { IRoundBet } from "../../core/round/interfaces";

enum EStatisticsActions {
    AddRemoveBetRecords = "Add/Remove Bet Records",
    UpdateSingleBetRecord = "Update Single Bet Record",
    ClearBetRecords = "Clear Bet Records",
    UpdateLastPageFlag = "Update Last Page Flag"
}

export const addRemoveBetRecords = createAction(EStatisticsActions.AddRemoveBetRecords, props<{ bets: IRoundBet[] }>());
export const updateBetRecord = createAction(EStatisticsActions.UpdateSingleBetRecord, props<{ bet: Partial<IRoundBet> & Pick<IRoundBet, "id"> }>());
export const clearBetRecords = createAction(EStatisticsActions.ClearBetRecords);
export const updateStatisticsLastPageFlag = createAction(EStatisticsActions.UpdateLastPageFlag, props<{ reachedLastPage: boolean }>());
